import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Switch } from "./ui/switch";

const STORAGE_KEY = "lq_cookie_consent";

export const CookieConsent = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const [managing, setManaging] = useState(false);
  const [prefs, setPrefs] = useState({ necessary: true, analytics: true, preferences: true });

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  if (pathname.startsWith("/admin")) return null;

  const persist = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...choice, necessary: true, ts: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-bar" role="dialog" aria-label="Cookie consent" data-testid="cookie-consent">
      {!managing ? (
        <>
          <h4>We value your privacy</h4>
          <p>
            We use cookies to keep our site secure, understand how it is used, and remember your
            preferences. You can accept all, reject non-essential cookies, or manage your choices.
            Read our <Link to="/cookie-policy">Cookie Policy</Link>.
          </p>
          <div className="cookie-actions">
            <button className="btn btn-primary" onClick={() => persist({ analytics: true, preferences: true })} data-testid="cookie-accept">
              Accept all
            </button>
            <button className="btn btn-ghost" onClick={() => persist({ analytics: false, preferences: false })} data-testid="cookie-reject">
              Reject
            </button>
            <button className="btn btn-ghost" onClick={() => setManaging(true)} data-testid="cookie-manage">
              Manage preferences
            </button>
          </div>
        </>
      ) : (
        <>
          <h4>Manage cookie preferences</h4>
          <div className="cookie-prefs">
            <div className="cookie-pref">
              <div>
                <div className="cp-title">Strictly necessary</div>
                <div className="cp-desc">Required for core site functionality. Always active.</div>
              </div>
              <Switch checked disabled aria-label="Necessary cookies" data-testid="pref-necessary" />
            </div>
            <div className="cookie-pref">
              <div>
                <div className="cp-title">Analytics</div>
                <div className="cp-desc">Helps us understand how the site is used.</div>
              </div>
              <Switch checked={prefs.analytics} onCheckedChange={(v) => setPrefs((p) => ({ ...p, analytics: v }))} aria-label="Analytics cookies" data-testid="pref-analytics" />
            </div>
            <div className="cookie-pref">
              <div>
                <div className="cp-title">Preferences</div>
                <div className="cp-desc">Remembers choices to personalise your experience.</div>
              </div>
              <Switch checked={prefs.preferences} onCheckedChange={(v) => setPrefs((p) => ({ ...p, preferences: v }))} aria-label="Preference cookies" data-testid="pref-preferences" />
            </div>
          </div>
          <div className="cookie-actions">
            <button className="btn btn-primary" onClick={() => persist(prefs)} data-testid="cookie-save">
              Save preferences
            </button>
            <button className="btn btn-ghost" onClick={() => setManaging(false)} data-testid="cookie-back">
              Back
            </button>
          </div>
        </>
      )}
    </div>
  );
};
